<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="Prelim-text">Dawit was born and brought up in Asmara, Eritrea. After completing high school in his homeland, he left for Italy at a young age. He accumulated years of experience in various fields; among these, he was privileged to travel as a sailor across the world, which fueled his vivid and colorful imagination. </p>
<p class="Prelim-text">Despite not having undertaken any formal writing courses, Dawit mulled over <em class="italic _idGenCharOverride-1">The Long Dark Trail</em> (formerly known as <em class="italic _idGenCharOverride-1">The Verdict of Time</em>) for decades, taking inspiration from his many personal experiences as well as from books, films, travels, folklore, people and nature. </p>
<p class="Prelim-text">Dawit first wrote the story in Tigrigna, his native language. He then proceeded to collaborate with an esteemed group of translators to work on the Amharic and English versions simultaneously. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528957960_EPUB.vue?77489c7a